// Canonical representation of "end of day / midnight" for shift end times, shared across the whole
// monorepo (backend storage, back-office calendar, forms). A shift end of "00:00" (midnight) is
// ambiguous with a lexicographic HH:mm compare (it sorts before any start time), so we normalize it
// to "24:00", which PostgreSQL's `time` type accepts and which sorts after every real time-of-day.
// Start times are never normalized: "00:00" as a start legitimately means the beginning of the day.
export const END_OF_DAY_TIME = '24:00'

// Midnight as emitted by time pickers (whose latest selectable hour is 23) and on the wire.
export const MIDNIGHT_START_TIME = '00:00'

// True when the given end time represents midnight / end of day. The picker emits "00:00" for
// midnight while the backend stores the canonical "24:00"; both mean the same instant.
export const isMidnightEnd = (time: string): boolean =>
  time === MIDNIGHT_START_TIME || time === END_OF_DAY_TIME

// Normalize a shift *end* time: midnight becomes the canonical "24:00", everything else is returned
// untouched. Safe to call on already-normalized values.
export const normalizeEndTime = (endTime: string): string =>
  endTime === MIDNIGHT_START_TIME ? END_OF_DAY_TIME : endTime
